import React, { useState } from 'react';
import './dropdown.css';
import imgChevronUp from './chevron-up.svg'
import imgChevronDown from './chevron-down.svg';

export type IDropdownOption = {
    label: string,
    value: string | number;
}

interface DropdownProps {
    /**
     * Is this the principal call to action on the page?
     */
    primary?: boolean;
    /**
     * What background color to use
     */
    backgroundColor?: string;
    /**
     * How large should the dropdown be?
     */
    size?: 'small' | 'medium' | 'large';
    /**
     * An additional label, to indicate what the dropdown is for
     */
    value: any | IDropdownOption,
    /**
     * Dropdown list items contents
     */
    options: any[] | {
        label: string,
        value: string | number,
    }[];
    /**
     * On change handler, triggered when an option is selected
     */
    onChange?: (item: any | { label: string, value: string }) => void;
}

/**
 * Primary UI component for user interaction
 */
export const Dropdown = ({
    primary = false,
    size = 'medium',
    backgroundColor,
    value,
    options,
    onChange,
    ...props
}: DropdownProps) => {
    // #region STATE
    const [isOpen, setOpen] = useState<boolean>(false)
    //#endregion

    //#region HANDLERS
    const handleToggle = () => {
        setOpen((prevState: boolean) => !prevState)
    }

    const handleSelect = (value: any | {
        label: string,
        value: string
    }) => {
        onChange?.(value)
        handleToggle();
    }
    // #endregion

    return (
        <div className="dd-wrapper">
            <button
                type="button"
                className="dd-header"
                onClick={handleToggle}
            >
                <div className="dd-header-title">{value.label}</div>
                <div>

                    {isOpen
                        ? <img alt="chevron-up" src={imgChevronUp} />
                        : <img alt="chevron-down" src={imgChevronDown} />}
                </div>
            </button>
            {isOpen && (
                <div
                    role="list"
                    className="dd-list"
                >
                    {options
                        ?.filter((o: any) => o.value !== value.value)
                        ?.map((item: any | {
                        label: string,
                        value: string
                    }) => (
                        <button
                            type="button"
                            className="dd-list-item"
                            key={item.id}
                            onClick={() => handleSelect(item)}
                        >
                            {item.label || 'thing'}
                            {' '}
                            {/* {item.selected && <img name="check" />} */}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}

export default Dropdown;